export const ADD_SELECTED_BLOCK = 'selectedBlocksTypes/ADD_SELECTED_BLOCK';
export const REMOVE_SELECTED_BLOCK = 'selectedBlocksTypes/REMOVE_SELECTED_BLOCK';
export const SELECT_ALL_BLOCKS = 'selectedBlocksTypes/SELECT_ALL_BLOCKS';
export const REMOVE_ALL_SELECTED_BLOCKS = 'selectedBlocksTypes/REMOVE_ALL_SELECTED_BLOCKS';
